export default __webpack_public_path__ + "static/media/table3.4e3b7c01.png";